<template>
   <div>
    <el-select
style="width: 100%;"
:value="selectShop"
filterable
remote
:placeholder="$t('pages_deduct_coupon_rule_components_scopeofuse_product_450')"
:remote-method="remoteMethod"
@change="onChange"
          >
          <el-option
            v-for="i in products"
            :value="i.id"
            :key="i.id"
            :label="i.name"
          >
          </el-option>
        </el-select>
   </div>
</template>

<script>
import i18n from '../../../../locales/index'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ScopeProduct',
  components: {},
  data () {
    return {
      selectShop: '',
      searchValue: ''
    }
  },
  computed: {
    ...mapGetters('product', ['products', 'meta', 'loading']),
  },
  created () {
    this.index()
  },
  methods: {
    ...mapActions('product', [
      'index',
      'changeQuery'
    ]),
    ...mapMutations('product', ['changeQuery']),

    remoteMethod (query) {
      if (query !== '') {
        this.searchValue = query
        this.changeQuery({ 'q[name_eq]': this.searchValue })
        this.index()
      }
    },
    onChange (value) {
      this.selectShop = value
      const product = this.products.find(item => item.id === value)
      this.$emit('product', {
        name: product.name,
        value: product.id,
      })
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
